import React from 'react'
import Button from '../../common/Button'
import { useDispatch } from 'react-redux'
import { toggleModal } from '../../../reducers/modalReducer'

const FractionHelpClientCard = ({ title, description, testimonial, index, author, imageDescription = null, setHelpClientModal }) => {

    const dispatch = useDispatch()
    let image = ''
    if (index === 0) image = require('../../../../images/fractional/helpClient/1.svg')
    if (index === 1) image = require('../../../../images/fractional/helpClient/5.svg')
    if (index === 2) image = require('../../../../images/fractional/helpClient/3.svg')

    let bottomImage = ''
    if (index === 0) bottomImage = require('../../../../images/fractional/helpClient/30.svg')
    if (index === 1) bottomImage = require('../../../../images/fractional/helpClient/18.svg')
    if (index === 2) bottomImage = require('../../../../images/fractional/helpClient/10.svg')

    return (
        <>
            <div className='bg1 br20px shadow pr' style={{ paddingBottom: '220px', width: '32%', position: 'relative' }}>
                <img
                    style={{
                        top: '-45px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                    }}
                    className='pa'
                    width={90}
                    height={90}
                    src={image}
                    alt="helpClient"
                />

                <div className='pt3rem px2rem'>

                    {title}
                    {description}

                    <div className='w100 tac'>
                        <img
                            className='mxa w50'
                            src={bottomImage}
                            alt="30%"
                        />
                        {
                            imageDescription && <p style={{ color: '#514949', marginBottom: '23px' }} className='fs12px'> {imageDescription}</p>
                        }
                    </div>

                    <div className='w100 tac moreButton' style={{ position: 'absolute', bottom: '160px', left: '50%', transform: 'translateX(-50%)' }}>
                        <Button
                            text={'More'}
                            btnType='warningOutlined'
                            customClassName='mxa my1rem w200px'
                            onClick={() => {
                                setHelpClientModal(index === 0 ? 'reduce' : index === 1 ? 'systematically' : 'maximise')
                                dispatch(toggleModal({ open: `fractionHelpClient` }))
                            }}
                        />
                    </div>
                </div>

                <div className='p2rem pa b0 footer' style={{
                    background: '#FFEBEB',
                    borderRadius: '0px 0px 20px 20px',
                    height: '160px'
                }}>
                    <p className='fs14px tac fw300' style={{ color: '#514949' }}> {testimonial} </p>
                    <p className="fs14px fw500 c2 tac mt0-5rem">{author}</p>
                </div>

            </div>
        </>
    )
}

const FractionHelpClientSection = ({ setHelpClientModal }) => {

    const data = [
        {
            title: <h3 className='w100 tac c15 fs1-5rem'>Reduce <br></br> Fundraising Stress</h3>,
            description: <p className='w100 tac mt1rem mb1rem' style={{ color: '#514949', minHeight: '100px' }}>We guide your clients through a clear, step-by-step process, reducing the time and stress of fundraising by a target</p>,
            testimonial: '“Putting a deal in front of a VC with the Diligentsia outputs alongside the deck. You’ve answered 50 questions they didn’t even ask yet.”',
            author: 'CL, Fractional CFO',
        },
        {
            title: <h3 className='w100 tac c15 fs1-5rem'>Systematically <br></br> Create Value</h3>,
            description: <p className='w100 tac mt1rem mb1rem' style={{ color: '#514949' }}>Use our <span className='fw500'>18 Healthboost modules</span>, all bespoked with AI, to systematically create value. Or use our partner modules in our Diligentsia AppStore.</p>,
            testimonial: '“It amplifies my ability to show value to a client—without the client even realising how much I’ve leveraged the platform.”',
            author: 'FR, Fractional CFO',
        },
        {
            title: <h3 className='w100 tac c15 fs1-5rem'>Maximise <br></br> Exit Value</h3>,
            description: <p className='w100 tac mt1rem mb1rem' style={{ color: '#514949' }}>We help you maximise value, get exit ready, and then increase buyer interest by presenting a pre-diligenced opportunity. We aim for</p>,
            imageDescription: '*Metrics based on internal case studies and user-reported data',
            testimonial: '“You have an architecture which comes from your years of experience as to what people are looking for.”',
            author: 'JC, Fractional CFO',
        }
    ]

    return (
        <>
            <div
                className='p5rem FractionHelpClientSection'
                style={{
                    backgroundImage: `url(${require('../../../../images/fractional/helpClient/helpClient.png')})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            >

                <div className='df aifs '>
                    <div className='df aifs fdc jcfs w70'>
                        <h2 className='c15 fs1-75rem w100 tal fw400'>How we help your <span className='c4'>clients?</span></h2>
                        <p className='c15 fs18px w100 tal'>We have built the lifecycle platform that we would want to use ourselves - hop on anywhere</p>
                    </div>

                    <div className='w30 tar' >
                        <img
                            style={{
                                width: '160px'
                            }}
                            src={require('../../../../images/fractional/helpClient/lifeCycleIcon1.png')}
                            alt="lifeCycleIcon1"
                        />
                    </div>

                </div>

                <div className='df jcsb mt3rem' style={{ gap: '1rem', flexWrap: 'wrap' }}>
                    {
                        data.map((item, index) => (
                            <FractionHelpClientCard key={index} index={index} setHelpClientModal={setHelpClientModal} {...item} />
                        ))
                    }
                </div>

            </div>
        </>
    )
}

export default FractionHelpClientSection